import apiClient from '../apiClient';

// Email Templates API calls

export const getEmailTemplates = () => {
  return apiClient.get('/api/emailTemplates');
};

export const createEmailTemplate = (templateData) => {
  return apiClient.post('/api/emailTemplates', templateData);
};

export const updateEmailTemplate = (templateId, templateData) => {
  return apiClient.put(`/api/emailTemplates/${templateId}`, templateData);
};

export const deleteEmailTemplate = (templateId) => {
  return apiClient.delete(`/api/emailTemplates/${templateId}`);
};
